import { Route, Routes } from 'react-router-dom';
import { TagsPage } from './TagsPage';
import { ModifyTagPage } from './ModifyTagPage';

export const TagsPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyTagPage />} />
    <Route path='/:tagID' element={<ModifyTagPage />} />
    <Route path='*' element={<TagsPage />} />
  </Routes>
);
